import { FunctionComponent, PropsWithChildren, createContext } from 'react';

import { DomEventBus } from '../adapters/dom.event.bus';
import { VerboseDomEventBus } from '../adapters/verbose.dom.event.bus';
import { EventBus } from '../ports/event-bus';
import { ENVIRONMENT } from '../variables';

const provide = () => {
    if (['local'].includes(ENVIRONMENT)) {
        return new VerboseDomEventBus();
    }
    return new DomEventBus();
};

type IEventBusContext = { eventBus: EventBus };

const defaultValue: IEventBusContext = {
    eventBus: provide(),
};

export const EventBusContext = createContext<IEventBusContext>(defaultValue);

export const EventBusProvider: FunctionComponent<PropsWithChildren> = ({ children }) => (
    <EventBusContext.Provider value={defaultValue}>{children}</EventBusContext.Provider>
);
